import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', color = 'gold' }) => {
  const sizes = {
    small: '20px',
    medium: '40px',
    large: '60px',
  };

  return (
    <div 
      className={`spinner ${color}`}
      style={{
        width: sizes[size],
        height: sizes[size],
      }}
    >
      <div className="spinner-inner"></div>
    </div>
  );
};

export default LoadingSpinner;